import React from 'react';

import styles from './index.module.scss';

import { Translation, Signature } from '../../common';

import manDog from '../../../assets/img/feedback/man-dog.jpg';

class Feedback extends React.Component {
  render() {
    const { avatarComponent: NamedAvatar, logo, showTopImage } = this.props;
    return (
      <div className={styles['feedback__wrapper']}>
        {showTopImage ? (
          <div className={styles['feedback__head-wrapper']}>
            <div className={styles['feedback__head']}>
              <img
                className={styles['feedback__head-image-man-dog']}
                src={manDog}
                alt="man-dog"
              />
              <img
                className={styles['feedback__head-image-logo']}
                src={logo}
                alt="logo"
              />
              <div className={styles['feedback__head-content']}>
                <h1>
                  <Translation>FEEDBACK_INSTALLMENT_PHOTO_TEXT</Translation>
                </h1>
              </div>
            </div>
          </div>
        ) : null}
        <div className={styles['feedback__content-wrapper']}>
          <h1 className={styles['feedback__content-header']}>
            <Translation>FEEDBACK_THANKS_HEADLINE</Translation>
          </h1>
          <div className={styles['feedback__content']}>
            <div className={styles['feedback__spacer']} />
            <NamedAvatar className={styles['feedback__avatar']} />
            <Translation className={styles['feedback__content-text']}>
              FEEDBACK_INSTALLMENT_THANKS_TEXT
            </Translation>
            <Signature className={styles['feedback__signature']} />
          </div>
        </div>
      </div>
    );
  }
}

export default Feedback;
